module.exports = __webpack_public_path__ + "static/media/rupee-bag.81d05f39.png";